import React, {FC, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import FormPanel from '../../../components/FormPanel';
import ensureCsrfCookie from '../../../utils/ensureCsrfCookie';
import GradientHeading from '../components/GradientHeading';
import Page from '../components/Page';
import {
	Alert,
	AlertIcon,
	AlertTitle,
	Button,
	Center,
	FormControl,
	FormLabel,
	HStack,
	Input,
	Text,
} from 'components/ui/chakra';
import RegisterController from 'puddleglum/api/auth/RegisterController';

const SignupForm: FC = () => {
	const navigate = useNavigate();
	const [errorText, setErrorText] = useState<string>();
	const [isLoading, setIsLoading] = useState(false);
	const [email, setEmail] = useState<string>();

	const sendVerificationCode = async () => {
		try {
			setErrorText(undefined);
			setIsLoading(true);
			await ensureCsrfCookie();
			await RegisterController.lookupEmailAndSendVerification({
				email: email ?? '',
			});
			navigate('/signup/verify', {state: {email}});
		} catch (error: any) {
			setErrorText(
				error?.response?.data?.message ??
					'Unable to start verification right now. Please try again.',
			);
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<Page>
			<Center w='100%' h='100vh'>
				<FormPanel
					description='Use your work email to confirm that your employer has already enrolled you in Allora.'
					maxW='600px'
					minW={{base: '90%', md: '50%', lg: '40%'}}
				>
					<GradientHeading>Verify Enrollment</GradientHeading>
					{errorText && (
						<Alert status='error' borderRadius='md' my={4}>
							<AlertIcon />
							<AlertTitle>{errorText}</AlertTitle>
						</Alert>
					)}
					<Text>
						In order to use Allora Health, your employer must have enrolled you in the
						program. Please enter your work email address below to verify your
						enrollment.
					</Text>
					<FormControl id='email' my={2}>
						<FormLabel>Email</FormLabel>
						<Input
							type='email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</FormControl>
					<HStack justifyContent='space-between' py={4}>
						<Button type='reset' variant='outline' onClick={() => navigate('/')}>
							Cancel
						</Button>

						<Button
							type='submit'
							colorScheme='blue'
							isLoading={isLoading}
							onClick={sendVerificationCode}
						>
							Submit
						</Button>
					</HStack>
				</FormPanel>
			</Center>
		</Page>
	);
};

export default SignupForm;
